var exports = {
  "k": "x52a3aa3b--e903af--container",
};

module.exports = exports;
